import { ENV } from "../utils";

export class LegalRequirement {
  baseApi = ENV.BASE_API;

  async getLegalRequirements(accessToken, filters = {}) {
    try {
      const params = new URLSearchParams();
      if (filters.active !== undefined) params.append("active", filters.active);
      if (filters.site) params.append("site", filters.site);
      if (filters.area) params.append("area", filters.area);
      if (filters.company) params.append("company", filters.company);
      const url = `${this.baseApi}/legal-requirements?${params.toString()}`;
      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getLegalRequirement(accessToken, id) {
    try {
      const url = `${this.baseApi}/legal-requirement/${id}`;
      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createLegalRequirement(accessToken, data) {
    try {
      const url = `${this.baseApi}/add-legal-requirement`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateLegalRequirement(accessToken, id, data) {
    try {
      const url = `${this.baseApi}/update-legal-requirement/${id}`;
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async copyYear(accessToken, ids, toYear) {
    try {
      const url = `${this.baseApi}/legal-requirement/copy-year`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ ids, toYear }),
      });
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async uploadFile(accessToken, id, formData) {
    try {
      const url = `${this.baseApi}/legal-requirement/${id}/upload-file`;
      const response = await fetch(url, {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getFile(accessToken, fileName) {
    try {
      const url = `${this.baseApi}/legal-requirement-file/${fileName}`;
      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (!response.ok) return null;
      const blob = await response.blob();
      return URL.createObjectURL(blob);
    } catch {
      return null;
    }
  }

  async deleteFile(accessToken, id, fileName) {
    try {
      const url = `${this.baseApi}/legal-requirement/${id}/delete-file`;
      const response = await fetch(url, {
        method: "DELETE",
        body: JSON.stringify({ fileName }),
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      });
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async uploadOccurrenceFile(accessToken, id, formData) {
    try {
      const url = `${this.baseApi}/legal-requirement/${id}/upload-occurrence-file`;
      const response = await fetch(url, {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteLegalRequirement(accessToken, id) {
    try {
      const url = `${this.baseApi}/delete-legal-requirement/${id}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
